import { PTextListItem, PTextList } from '@porsche-design-system/components-react';
import { trim } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type ListItemProps } from '../context';

const StyledListItem = styled(PTextListItem)`
    &::before {
    }
`;

const ListItem = ({ translationKey }: ListItemProps) => {
    const { t } = useTranslation(['myInfo']);
    const listing = t(translationKey);

    const array = listing
        .replaceAll('</l>', '')
        .split('<l>')
        .filter(Boolean)
        .map(text => trim(text));

    if (array.length === 0) {
        return null;
    }

    return (
        <PTextList>
            {array.map((text, index) => (
                <StyledListItem key={`${text}-index`}>{text}</StyledListItem>
            ))}
        </PTextList>
    );
};

export default ListItem;
